import { render, staticRenderFns } from "./statistarehouse.vue?vue&type=template&id=0adcfb26&scoped=true&"
import script from "./statistarehouse.vue?vue&type=script&lang=js&"
export * from "./statistarehouse.vue?vue&type=script&lang=js&"
import style0 from "./statistarehouse.vue?vue&type=style&index=0&id=0adcfb26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adcfb26",
  null
  
)

export default component.exports